import React, { useRef } from 'react';
import PropTypes, { InferProps } from 'prop-types';
import { useRouter } from 'next/router';
import { ProductsListWrapper } from '@fuww/library/src/Products';
import ProductListItem, {
  productsListItemPropertyTypes,
} from './ProductListItem';
import withQuery from '../../lib/withQuery';
import loadMore from '../../lib/queries/loadMore';
import LoadMore from '../LoadMore';
import { getHeight, useSaveHeight } from '../../lib/useSaveHeight';
import { ProductsConnectionQuery } from '../../lib/graphql/api/graphql';

const productsListPropertyTypes = {
  loading: PropTypes.bool.isRequired,
  variables: PropTypes.shape({}).isRequired,
  fetchMore: PropTypes.func.isRequired,
  ...productsListItemPropertyTypes,
};

type ProductsListProperties = InferProps<
  typeof productsListPropertyTypes
> & {
  data: ProductsConnectionQuery;
};

const ProductsList = ({
  data,
  variables,
  fetchMore,
  loading,
  standId = null,
  marketId = null,
  favoriteIds,
  updateFavorites,
  route: detailsRoute,
  includeProfile,
}: ProductsListProperties) => {
  const { productsConnection: { edges, pageInfo: { hasNextPage } } } = data;

  const { route, query } = useRouter();
  const heightElement = useRef(null);

  useSaveHeight(heightElement, route, query);

  return (
    <div
      ref={heightElement}
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: getHeight(route, query),
      }}
    >
      <ProductsListWrapper>
        {edges.map(({
          node: product,
        }) => (
          <ProductListItem
            {...product}
            key={product.id}
            marketId={marketId}
            standId={standId}
            route={detailsRoute}
            includeProfile={includeProfile}
            updateFavorites={updateFavorites}
            favoriteIds={favoriteIds}
          />
        ))}
      </ProductsListWrapper>
      <LoadMore
        loading={loading}
        hasNextPage={hasNextPage}
        fetchMore={
          () => loadMore({ variables })(data, 'productsConnection', fetchMore)
        }
      />
    </div>
  );
};

ProductsList.propTypes = productsListPropertyTypes;

export default withQuery(ProductsList);
